// @flow
import React, { PureComponent } from 'react';
import Linkify from 'app/common/react/components/Activities/Utils/Linkify';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Text } from 'gestalt';

type Props = {
  allowLink?: boolean,
  taggedUsers: Array<Object>,
  tags: Array<Object>,
  text: string,
  size: 'sm' | 'md' | 'lg' | 'xl',
};

export default class TaggedText extends PureComponent<Props> {
  static defaultProps = {
    allowLink: true,
    size: 'md',
  };

  parseText = () => {
    const { tags, taggedUsers, text, size } = this.props;
    if (!tags.length || !taggedUsers || tags.length !== taggedUsers.length) {
      return this.renderRegularText(text, '1');
    }
    let index = 0;
    let parsedComponents = [];
    tags.forEach((tag, i) => {
      const textBefore = text.substring(index, tag.offset);
      index = tag.offset + tag.length;
      const taggedText = text.substring(tag.offset, index);
      parsedComponents = parsedComponents
        .concat(this.renderRegularText(textBefore, `${i}a`))
        .concat(this.renderTaggedText(taggedText, i, `${i}b`));
    });
    parsedComponents = parsedComponents.concat(this.renderRegularText(text.substring(index), '2'));
    return (
      <Text inline leading="tall" size={size}>
        {parsedComponents}
      </Text>
    );
  };

  renderRegularText = (text: string, key: string) => (
    <Text key={key} inline leading="tall" size={this.props.size}>
      {/* Text in comments should never be linkified */}
      {this.props.allowLink ? <Linkify>{text}</Linkify> : text}
    </Text>
  );

  renderTaggedText = (text: string, i: number, key: string) => (
    <NavigateLink key={key} stopPropagation to={`/${this.props.taggedUsers[i].username}`}>
      <Text color="blue" inline leading="tall" size={this.props.size} weight="bold">
        {text}
      </Text>
    </NavigateLink>
  );

  render() {
    return <span style={{ whiteSpace: 'pre-wrap' }}>{this.parseText()}</span>;
  }
}
